// SignIn.js
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import authenticationService from '../Utilities/authenticationService';

import { useSelector, useDispatch } from 'react-redux';

import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Password } from 'primereact/password';

import Menubar1 from '../Components/Menubar1';

import { VERSION, DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

export default function Profile(props) { 

  const { reset4All, setCredential, setUsernameErrorMessage, setUsername, setInProgress, setUsernameError, setSupervisorList, setManagerList, setAssignList, setServiceList, setMemberList } = reducer;
  const { FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, Search, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem, SystemConfig } = component;  
  const { postLogListItem, deleteVerseReadLogListItem, postVerseReadLogListItem, postHistoryListItem, getHasNoteVerses, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, chapter4SetVerseReadLogList, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();
  
  const navigate = useNavigate();
  
  const dispatch = useDispatch(); // dispatch(
  const username = useSelector((state) => state.signIn.username);
  //const password = useSelector((state) => state.signIn.password);
  const inProgress = useSelector((state) => state.signIn.inProgress);
  const usernameErrorMessage = useSelector((state) => state.signIn.usernameErrorMessage);
  const credential = useSelector((state) => state.signIn.credential);
  const userListItem = useSelector((state) => state.all.userListItem); 

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [newPasswordErrorMessage, setNewPasswordErrorMessage] = useState('');

  const [newPasswordRetype, setNewPasswordRetype] = useState('');
  const [newPasswordRetypeError, setNewPasswordRetypeError] = useState(false);
  const [newPasswordRetypeErrorMessage, setNewPasswordRetypeErrorMessage] = useState('');  

  const [updated, setUpdated] = useState(false);
  const [updatedMessage, setUpdatedMessage] = useState('');  


  const handleSubmit = (e) => {

    e.preventDefault();

    let isValid = true;

    let newPasswordOK = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/.test(newPassword);
    if (!newPassword || newPassword.length === 0) {
      setNewPasswordError(true);
      setNewPasswordErrorMessage('需要輸入密碼');
      isValid = false;  
    } else if (!newPasswordOK) {
        setNewPasswordError(true);
        setNewPasswordErrorMessage('密碼組合錯誤，請重新輸入');
        isValid = false;      
    } else {
        setNewPasswordError(false);
        setNewPasswordErrorMessage('');
        if (newPasswordRetype !== newPassword) {
            setNewPasswordRetypeError(true);
            setNewPasswordRetypeErrorMessage('兩組密碼不符，請重新輸入');
            isValid = false;      
        } else {
            setNewPasswordRetypeError(false);
            setNewPasswordRetypeErrorMessage('');
        }   
    }  
    
    if (isValid) {
        setUpdated(true);
        setUpdatedMessage('已經更新');
        const httpPostData = {
          Credential: credential,
          Password: newPassword,
          Updated: { Password: true }
        };
        putUserListItem(httpPostData);
    }
    else {

    }

  };

  const validateInputs = (e) => {
    handleSubmit(e);
  };

  useEffect(() => {
    //dispatch(reset4All());
  }, []);

 return (

    <>

    <Menubar1 />

    <div className="w-full flex justify-content-center mt-0">

      {/* --- CSS OVERRIDE FOR PRIMEREACT PASSWORD BUG --- */}
      <style>{`
        .force-full-width,
        .force-full-width .p-icon-field,
        .force-full-width .p-password-input {
            width: 100% !important;
        }
      `}</style>
      {/* ------------------------------------------------ */}

      <Card title="個人設定"
        style={{ 
            width: '100%',       
            maxWidth: '30%',    
            minWidth: '320px'   
        }}            
      >

        <div className="flex flex-column gap-3">

            <label htmlFor="email">電子郵件地址</label>
            <InputText 
                id="email" 
                value={userListItem.Email} 
                //onChange={onChangeUsername} 
                className="w-full"
                readOnly
                style={{ color: 'lightGray' }}
            />      

            <label htmlFor="username">帳戶名稱</label>
            <InputText 
                id="username" 
                value={userListItem.UserName} 
                //onChange={onChangeUsername} 
                className="w-full"
                readOnly
                style={{ color: 'lightGray' }}
            />  

            <label htmlFor="newPassword">新密碼 (組合至少 8 個字元，包括大小寫字母、數字和符號)</label>
            <Password 
                id="newPassword" 
                value={newPassword} 
                onChange={e => setNewPassword(e.target.value)} 
                toggleMask               
                feedback={false}         
                className="force-full-width" // <-- Attach the custom override class here
            />  
            
            {newPasswordError && (
              <div className="p-error">
                {newPasswordErrorMessage}
              </div>
            )}                                 

            <label htmlFor="newPasswordRetype">重新輸入密碼</label>
            <Password 
                id="newPasswordRetype" 
                value={newPasswordRetype} 
                onChange={e => setNewPasswordRetype(e.target.value)} 
                toggleMask               
                feedback={false}         
                className="force-full-width" // <-- Attach the custom override class here
            /> 

            {newPasswordRetypeError && (
              <div className="p-error">
                {newPasswordRetypeErrorMessage}
              </div>
            )}  

            <Button
              type="submit"
              onClick={validateInputs}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              更新              
            </Button>

            {updated && (
              <div className="p-error text-center" style={{ textAlign: 'center' }}>
                {updatedMessage}
              </div>
            )}

        </div>     

      </Card>

      {inProgress && (
          <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999 
          }}>
              <ProgressSpinner style={{width: '250px', height: '250px'}} strokeWidth="1" />
          </div>
      )}      

    </div>

  </>

  );

}